import styled from 'styled-components';

export const PlaysWrapper = styled.div``;
